import { useQuery } from '@tanstack/react-query'
import { supabase } from '../../api'

const getUserActivities = async (id) => {
  const { data, error } = await supabase
    .from('profile_privacy_activity')
    .select('*')
    .eq('user_id', id)
    .order('id', { ascending: false })

  if (error) {
    throw new Error(error.message)
  }

  const tmp: any = {}

  if (data.length) {
    data.forEach((s: any) => {
      tmp[s.activity] = s.enabled
    })
  }

  return tmp
}

export default function useUserPrivacyActivities(id: string) {
  return useQuery({
    queryKey: ['useUserPrivacyActivities', id],
    queryFn: () => getUserActivities(id),
    enabled: Boolean(id),
    refetchOnMount: true,
  })
}
